import React, { useEffect, useState } from "react";
import { read } from "Helpers/LocalStorage";
import HomeService from "Services/http/endpoints/home/HomeService";
import StatusHandler from "Helpers/StatusHandler";
import MuiPaper from "Components/MuiPaper/MuiPaper";
import { Bar } from "react-chartjs-2";
import {
  ArcElement,
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  Title,
  Tooltip,
} from "chart.js";
import { Grid } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import InnerCircularProgress from "Components/InnerCircularProgress/InnerCircularProgress";

export default function CountProjectProvince({
  height = "300px",
  dataSearch = null,
}) {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
  );

  const options = {
    responsive: true,
    maintainAspectRatio: true,
    layout: {
      padding: 8,
    },
    plugins: {
      datalabels: {
        display: false,
      },
      legend: {
        display: false,
      },
      title: {
        display: true,
        text: t("projectsCount_province"),
        font: {
          family: "IRANSans",
          size: 12,
        },
      },
    },
  };

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const params = {
          KeyGroup: read("groupAKey"),
          KeyUser: read("userAKey"),
          IsAdminP: true,
          ...dataSearch,
        };
        const response = await HomeService.getBarCountProjectProvince(params);
        let err = StatusHandler(response);
        if (!err.isFail) {
          setData(response.data.Value);
        } else {
          setData(null);
        }
        setLoading(false);
      } catch (e) {
        setLoading(false);
      }
    })();
  }, [dataSearch]);

  return (
    <MuiPaper className="mt-2">
      {loading ? (
        <InnerCircularProgress />
      ) : (
        <>
          {data && (
            <Bar
              options={options}
              data={data}
              type={"bar"}
              style={{ maxHeight: height }}
            />
          )}
        </>
      )}
    </MuiPaper>
  );
}
